import { accountTypeKeys } from "~/composables/account-type-details";
import omit from "lodash/omit";

export default {
  toUIData: {
    customerName(response) {
      return response?.data?.getCustomerName;
    },
    userProfile(response) {
      return response?.data?.getUserProfile.data;
    },
    bankList(response) {
      const bankResponseData = response?.data?.getBankList.data;

      const bankUiData = {
        customerProfile: {
          name: bankResponseData?.customerProfile?.name,
        },
        allowAddBank: false,
        bankList: [],
      };

      accountTypeKeys.forEach((accountTypeKey) => {
        const accountTypeBankListData = bankResponseData[accountTypeKey];
        if (!accountTypeBankListData) return;
        bankUiData.allowAddBank =
          bankUiData.allowAddBank || accountTypeBankListData?.allowAddBank;

        bankUiData.bankList = bankUiData.bankList.concat(
          accountTypeBankListData?.bankList?.map((element) => ({
            id:
              element.formData?.taBankInfo?.bankMicrIdentifier ||
              element.formData?.tracBankInfo?.reduce((str, obj) => {
                str += Object.values(obj).join("-");
                return str;
              }, ""),
            allowDelete: element.allowDelete,
            hasSystematic: element.hasSystematic,
            ...element.textData,
            otherPayloadData: element.formData,
          })) ?? []
        );
      });

      return bankUiData;
    },
    stateList(response) {
      return response?.data?.getStateList?.data;
    },
    addBankError(response) {
      return response?.data?.addBank?.data;
    },
  },
  toServicePayload: {
    deleteBank(bankData) {
      const { taBankInfo, tracBankInfo } = bankData.otherPayloadData;

      return {
        input: {
          taBankInfo: taBankInfo && {
            ...omit(taBankInfo, ["wireInstructionMap"]),
            inputWireInstruction: Object.entries(
              taBankInfo.wireInstructionMap
            ).map(([wireInstructionId, lastMaintenanceDateTime]) => ({
              wireInstructionId,
              lastMaintenanceDateTime,
            })),
          },
          tracBankInfo,
        },
      };
    },
    addBank(bankData) {
      return {
        input: {
          bankAccount: {
            ...bankData,
          },
        },
      };
    },
  },
};
